import { defineMessage } from 'react-intl';

export const organizationCommonI18n = {
  business: defineMessage({
    id: 'common:organization.business',
    defaultMessage: 'Business'
  }),
  school: defineMessage({
    id: 'common:organization.school',
    defaultMessage: 'School'
  })
};
